/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Multi_Select_ConfirmInputs */



/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Chat_Multi_Select_ConfirmInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_multi_select_confirm = /** @type {((inputs?: Chat_Multi_Select_ConfirmInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Multi_Select_ConfirmInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bevestig")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmer")
	return /** @type {LocalizedString} */ ("Confirm")
});